import { render, staticRenderFns } from "./gameAnalysis.vue?vue&type=template&id=5293e8ec&scoped=true&"
import script from "./gameAnalysis.vue?vue&type=script&lang=js&"
export * from "./gameAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./gameAnalysis.vue?vue&type=style&index=0&id=5293e8ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293e8ec",
  null
  
)

export default component.exports